<template>
  <section v-if="!isLoggedIn">
    <p class="text-center pt-3"><q><em>{{ quote }}</em></q></p>
    <div v-if="successLogin" class="alert alert-success text-center" role="alert">
      <span class="font-size-xl">Logged in successfully !</span><br>
      <span>You will be redirect shortly to the insurance form page...</span>
    </div>
    <div v-if="!successLogin" class="d-flex flex-column flex-lg-row m-2">
      <div class="w-100 w-lg-50 bg-img leftContent">
        <div class="h-100 overlay pt-4 pb-2">
          <div class="p-2 d-flex flex-column justify-content-center divLogo rounded-circle">
            <img alt="log_app" src="../assets/logo_2.png" class="d-block img-fluid">
          </div>
          <article class="pt-2 pl-4 pr-4">
            <h1 class="text-center font-weight-bold font-size-xl"><i>Hey There !</i></h1>
            <p class="font-size-lg">
              <span>Are you a client of ATI  or have you already subscribed to one of our insurance plan ?</span>
            </p>
            <p><span>If yes, please fill-in the following form with your customer credentials.</span></p>
            <p><span>If no, please <router-link to="/register" class="text-white text-underline">sign-up</router-link>.</span></p>
          </article>
        </div>
      </div>
      <div class="w-100 w-lg-50 rightContent">
        <div class="d-flex justify-content-center mt-2">
          <h1 class="w-95 p-2 bg-color-grey border rounded text-center text-white font-size-xxl">Login Form</h1>
        </div>
        <form @submit.prevent="onSubmit" class="w-95">
          <div class="input-group mt-4">
            <label for="email" class="d-none"></label>
            <input @blur="$v.userDataForm.email.$touch()" v-model.lazy="userDataForm.email" type="email" name="email" id="email" class="form-control" placeholder="Enter your email address">
            <div class="divIconInput">
              <font-awesome-icon icon="envelope" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please provide a valid email address !</span>
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter an email address !</span>
          </div>
          <div class="input-group">
            <label for="password" class="d-none"></label>
            <input @blur="$v.userDataForm.password.$touch()" v-model.lazy="userDataForm.password" type="password" name="password" id="password" class="form-control" placeholder="Enter your password">
            <div class="divIconInput">
              <font-awesome-icon icon="lock" size="lg" class="text-color-grey"/>
            </div>
          </div>
          <hr class="mt-0 mb-0 bg-color-grey">
          <div v-if="$v.userDataForm.password.$error">
            <span v-if="!$v.userDataForm.password.minLength" class="text-danger">* Password must have at least {{ $v.userDataForm.password.$params.minLength.min }} characters !</span>
            <span v-if="!$v.userDataForm.password.required" class="text-danger">* Please enter your password !</span>
          </div>
          <div class="text-center mb-5">
            <button id="buttonLogin" type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Sign-In</button>
            <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
              <div class="emptyBox"><span class="invisible">Sign-In</span></div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script>
import { FORM_SIGNIN } from '../validations/formLogin'
import router from '../router'

export default {
  name: 'Login',
  data () {
    return {
      quote: this.$store.state.quotes[Math.floor(Math.random() * this.$store.state.quotes.length)],
      validForm: false,
      userDataForm: {
        email: '',
        password: ''
      },
      successLogin: false,
      isLoggedIn: false
    }
  },
  // check if user is logged in or not.
  created () {
    if (this.$store.state.token) {
      this.isLoggedIn = true
      router.back()
    }
  },
  methods: {
    // Login user after sending correct credentials
    onSubmit () {
      const formData = {
        username: this.userDataForm.email,
        password: this.userDataForm.password
      }
      console.log(formData)
      this.$store.dispatch('sign_in', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successLogin = true : this.successLogin = false
          setTimeout(() => router.replace('/'), 3000)
          console.log('response axios post users(login) = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the login form
  validations: FORM_SIGNIN
}
</script>

<style scoped>
@import "../assets/css/loginRegister.css";
.bg-img{
  background-image: url(../assets/img/img-login.jpg);
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue